export default () => {

  const runMode = ignite.getRunMode();

  switch(runMode) {
      case 'prod':
      case 'production':
          return {
            cognitoUrl: 'https://dev-480621733616.auth.us-east-1.amazoncognito.com/oauth2/token',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'Basic NWhpdTNnZWJxYWV2cWVlNGk0a29kMmtqZDE6a251c3VsYmJvN3ZuMWkwcDA2aW9yZG11NW9vcWZnN3NocWtzM2s4MnUzZDhlbzVoNmlk'
            },
            body: new URLSearchParams({
              grant_type: 'client_credentials',
              scope: 'dialogue-dev-prod/reporting'
            }),
            url: 'https://regions.dialogue.api.moneymatch.net/lead-processor/run',
          }
       case 'training':
        case 'int':
        case 'pilot':
          return {
            cognitoUrl: 'https://regions-ignite-dev.auth.us-east-1.amazoncognito.com/oauth2/token',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'Basic NzJna2tiMDNsbGdhamhnbHQzOTUyYzBncGE6ZzNjbWM1OWluc3NtMHNlZG82dXRnYTgwYmoxaHFsaGw3czAyczFmNWhmcmJkNWI0Z2dx'
            },
            body: new URLSearchParams({
              grant_type: 'client_credentials',
              scope: 'dialogue-regions-dev/reporting'
            }),
                url: 'https://regions-int.dialogue.api.moneymatch.net/lead-processor/run',
          }
        case 'staging':
        case 'qa':
          return {  
            cognitoUrl: 'https://dev-480621733616.auth.us-east-1.amazoncognito.com/oauth2/token',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'Basic NWhpdTNnZWJxYWV2cWVlNGk0a29kMmtqZDE6a251c3VsYmJvN3ZuMWkwcDA2aW9yZG11NW9vcWZnN3NocWtzM2s4MnUzZDhlbzVoNmlk'
            },
            body: new URLSearchParams({
              grant_type: 'client_credentials',
              scope: 'dialogue-dev-prod/reporting'
            }),
            url: 'https://pipeline-regions-qa.dialogue.api.moneymatch.net/lead-processor/run',
          }
        default:
          return {
            cognitoUrl: 'https://dev-480621733616.auth.us-east-1.amazoncognito.com/oauth2/token',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'Basic NWhpdTNnZWJxYWV2cWVlNGk0a29kMmtqZDE6a251c3VsYmJvN3ZuMWkwcDA2aW9yZG11NW9vcWZnN3NocWtzM2s4MnUzZDhlbzVoNmlk'
            },
            body: new URLSearchParams({
              grant_type: 'client_credentials',
              scope: 'dialogue-dev-prod/reporting'
            }),
            url: 'https://pipeline-dialogue-841.dialogue.api.moneymatch.net/lead-processor/run',
          }
      };

}
